<template>
    <BaseModal :id="'static'" :title="title" :size="'lg'">
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb" />
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_local()">
                <FormDynamic :form_format="form_format" :form_data="form_data" :array_options="array_options"
                    :for_update="false" />
                <div class="row">
                    <div class="col-12 mt-4">
                        <div class="table-responsive-md shadow-sm p-3 mb-3 bg-white rounded" v-if="!form_answers && form_data.questions.length">
                            <table>
                                <thead class="bg-white">
                                    <tr>
                                        <th scope="col" v-for="(val, i) in table_headers" :key="i" v-html="val.text" />
                                    </tr>
                                </thead>
                                <draggable v-model="form_data.questions" tag="tbody" @start="drag = true" @end="drag = false">
                                    <tr v-for="(val, i) in form_data.questions" :key="i"
                                        :class="val.status ? 'table-primary' : ''">
                                        <th scope="row" v-html="i + 1" />
                                        <td> <input class="form-control" v-model="val.question" required/> </td>
                            
                                        <td>
                                        <select class="input-field custom-select" :style="`font-size:12px; height: 32px;`" v-model="val.question_type_id" required>
                                            <option v-html="'Select an option'" value=""></option>
                                            <option v-for="(val, j) in array_options.question_type_id" :key="j" :value="val.id">{{val.name}}</option>

                                        </select>
                                        </td>
                                        <td>
                                            <select class="input-field custom-select" :style="`font-size:12px; height: 32px;`" v-model="val.response_type" required>
                                            <option v-html="'Select an option'" value=""></option>
                                            <option v-for="(val, k) in response_types" :key="k" :value="val.id">{{val.name}}</option>

                                        </select>
                                            </td>
                                        <td>
                                            <div class="mb-0 form-group">
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" v-model="val.status"
                                                        :id="`switch${i}`" @change="status_upgrade(i, val.status)" />
                                                    <label class="custom-control-label" :for="`switch${i}`" />
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                           <i class="fa fa-trash mr-2" style="font-size: 24px; cursor: pointer;" @click="delete_answer(i)"></i>
                                           <span style="margin-left: 5px;">
                                                    <img class="mb-2" :src="`/assets/img/svg/update_entry.svg`" style="width:21px; cursor: pointer;" alt="Update Entry Icon" 
                                                    @click="add_answers(i)" v-if="val.response_type == 1"/>
                                                </span>
                                           <!-- <i class="fa fa-info"  style="font-size: 24px; cursor: pointer;" @click="add_answers(i)" v-if="val.response_type == 1"></i> -->
                                        </td>
                                    </tr>
                                </draggable>
                            </table>
                        </div>
                        <span class="float-right" v-if="!form_answers"><a style="font-size: 14px; color: #039be5; text-decoration-line: underline;" @click="form_modal('static-question')"><b>Add Question</b></a></span>
                        <div class="row m-0 formdynamic justify-content-md-between shadow-sm p-3 mb-5 bg-white rounded" style="padding-top:10px;" v-if="form_answers">
                        <label class="modal-label"><b>Question: </b>{{survey_question_selected.question}}</label>
                            <div v-for="(item, i) in survey_question_selected.answers_data" :key="i" :class="'col-md-12'" class="p-0 formdynamic__item" :style="`margin-top:20px`">
                                <div class="formdynamic__item__field">
                                    <label v-html="`Answer #${i+1} <b style='color:red;'>*</b>`" class="modal-label"/>
                                    <input
                                        :type="'text'" 
                                        :maxlength="'150'"
                                        :required="true"
                                        v-model="item.answer_text"
                                    />
                                </div>
                            </div>
                            <div class="modal__buttons text-center text-md-right">
                                <button 
                                    v-if="survey_question_selected.answers_data.length < 5"
                                    type="button"
                                    class="modal__buttons__item" 
                                    v-html="`Add answer <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`" 
                                    style="margin-left:0px;"
                                    @click="pushAnswerField()"
                                />
                                <button 
                                    v-if="survey_question_selected.answers_data.length+1 > 3"
                                    type="button"
                                    class="modal__buttons__item" 
                                    v-html="`Remove last answer`"
                                    :style="survey_question_selected.answers_data.length >= 5 ? `margin-left:0px;` : ''"
                                    @click="spliceLastAnswerField()"
                                />

                                <button 
                                    type="button"
                                    class="modal__buttons__item" 
                                    v-html="`See questions`"
                                    @click="form_answers = false"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <CentralButtons style="margin-top: 50px" />
            </form>
        </template>
    </BaseModal>
</template>

<script>
import FormResources from "./form_resources";
import Resources  from './resources'
import FormDynamic from "@/components/FormDynamic.vue";
import Breadcrumb from "@/components/BreadcrumbComponent/Breadcrumb";
import BaseModal from "@/components/BaseModal";
import CentralButtons from "@/components/CentralButtons";
import draggable from "vuedraggable";
import eventBus from '@/plugins/eventBus'

export default {
    name: "FormModal",
    props: ["title", "rest_api", "notyf", "array_options", "breadcrumb"],

    components: {
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
        draggable,
    },

    data() {
        return {
            levels: [],
            areas: [],
            form_data: FormResources.form_data,
            form_format: FormResources.form_format,
            form_backup:  Object.assign({}, FormResources.form_data),
            response_types: Resources.response_types,
            table_headers: Resources.table_headers_answers,
            select_all: false,
            survey_question_selected: {},
            form_answers: false,
        };
    },

    methods: {
        form_submit_local()
        {
            let flat_answers = true;
            let message = "";
            this.form_data.questions.forEach((item, index) => {
                if (item.response_type == 1) {
                    item.answers_data.forEach((res)=>{
                        if(!res.answer_text && flat_answers)
                        {
                            flat_answers = false;
                            message = `Fill the answers in the question #${index + 1}`;
                        }
                    })
                }
            });

            if (flat_answers) {
                this.form_submit();
            } else {
                this.notyf.error(message);
            }
        
        },

        form_modal() {

            const template_obj = {
                question: '',
                question_type_id: '',
                response_type: '',
                status: true,
                order: this.form_data.questions.length + 1,
                answers_data: [
                    {
                        id: 1,
                        answer_text: ''
                    }
                ]
            }

            this.form_data.questions.push(template_obj)
        },
        add_answers(i)
        {
            if(!this.form_data.questions[i].question)
            {
                this.notyf.error('Write the question')
                return;
            }
            this.survey_question_selected = this.form_data.questions[i]
            this.form_answers = true
        },
        delete_answer(i)
        {
            this.form_data.questions.splice(i, 1)
        },
        pushAnswerField()
        {
            const template_obj = 
            {
                id: this.survey_question_selected.answers_data.length,
                answer_text: ''
            }
            this.survey_question_selected.answers_data.push(template_obj)
        },
        spliceLastAnswerField()
        {
            this.survey_question_selected.answers_data.splice(this.survey_question_selected.answers_data.length-1, 1)
        },

        status_upgrade(i, value)
        {
            this.form_data.questions[i].status = value
        },

    },
    created()
    {
        eventBus.$on('unshiftObject', () => {
            console.log('entro')
           this.form_backup.questions = []
        })

    },

    mounted() { },
};
</script>